import { createTheme } from '@mui/material/styles';

export const lightTheme = createTheme({
  typography: {
    fontFamily: 'var(--pm-font-family)',
  },
  palette: {
    mode: 'light',
    primary: {
      main: '#1472ff',
    },
    secondary: {
      main: '#9c27b0',
    },
    background: {
      paper: '#fff',
    },
    text: {
      primary: '#0e0f14',
      secondary: '#666666',
    },
    error: {
      main: '#ff3665',
    },
  },
});
